/* eslint-disable consistent-return */
import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'

import { DebugView, Logger, LoggerTypes } from '../../utils'
import { Button, buttonModes, buttonTypes } from '../../components'

export const DialogDelete = forwardRef(
  ({ openDialog, setOpenDialog, title, message, actionDispatchDelete, variable, projectId, scenarioId }, ref) => {
    const { t } = useTranslation()

    const onDialogClose = () => {
      setOpenDialog(false)
    }

    const onClickDelete = () => {
      actionDispatchDelete(variable?.id || variable, projectId, scenarioId)
      onDialogClose()
    }

    Logger.trace(LoggerTypes.CONTAINER, 'DialogDelete.render()', { openDialog, variable })

    return (
      <Dialog
        ref={ref}
        open={openDialog}
        // onClose={onDialogClose} // <-- close while clicking on background
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {title} {variable?.name || ''}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{message}</DialogContentText>
        </DialogContent>
        <DebugView>{variable}</DebugView>
        <DialogActions>
          <Button
            mode={buttonModes.SECONDARY_ACTION}
            type={buttonTypes.BUTTON}
            text={t('common.cancel')}
            icon={<CloseIcon />}
            onClick={onDialogClose}
          />
          <Button
            mode={buttonModes.PRIMARY_ACTION}
            type={buttonTypes.SUBMIT}
            text={t('common.delete')}
            icon={<DeleteOutlineIcon />}
            onClick={onClickDelete}
          />
        </DialogActions>
      </Dialog>
    )
  }
)

DialogDelete.displayName = 'DialogDelete'

DialogDelete.propTypes = {
  variable: PropTypes.object.isRequired,
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  actionDispatchDelete: PropTypes.func.isRequired,
  projectId: PropTypes.string,
  scenarioId: PropTypes.string
}

DialogDelete.defaultProps = {
  variable: null,
  openDialog: false,
  setOpenDialog: () => {},
  title: '',
  message: '',
  actionDispatchDelete: () => {},
  projectId: null,
  scenarioId: null
}
